import React, {FC, useEffect, useState} from 'react';
import {Flex, Scrollbar, Text, Title} from '@priority-software/priority-style-react';
import {NextState, WizardStepWelcome} from '../../types';
import WelcomeImage from '../../../../images/EOY-Welcome-image.svg';
import styles from './WelcomeStep.module.scss';
import {Footer} from '../Footer';
import {useFooterContext, useSideBarContext} from '../../hooks';
import texts from '../../texts';
import {useScrollWrapDimensions} from '../../../../hooks/customScroll/useScrollWrapDimensions';

export const WelcomeStep: FC = () => {
    const sideBarState = useSideBarContext();
    const currentStep = sideBarState.currentStep as WizardStepWelcome;
    const footerState = useFooterContext();

    const {maxHeight, setWrapRef} = useScrollWrapDimensions();

    useEffect(() => {
        if (footerState.onNextState === NextState.Processing) {
            footerState.setOnNextState(NextState.Done);
        }
    }, [footerState.onNextState]);

    const [height, setHeight] = useState(0);

    useEffect(() => {
        const updateWindowDimensions = () => {
            const newHeight = window.innerHeight;
            setHeight(newHeight);
        };

        window.addEventListener('resize', updateWindowDimensions);

        updateWindowDimensions();

        return () => window.removeEventListener('resize', updateWindowDimensions);
    }, []);

    const renderContent = () => (
        <Flex
            direction={'column'}
            componentClasses={styles.container}
            justifyContent={'space-between'}
            alignItems={'flex-start'}
        >
            <Title skin={'h1'} textColor={'primary-500'} componentClasses={styles.title}>
                {texts[currentStep.name]}
            </Title>
            <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-700'}>
                {texts[currentStep.description]}
            </Text>
            <img className={styles.welcomeImage} alt={''} src={WelcomeImage} />
            <Footer />
        </Flex>
    );

    return (
        <div ref={setWrapRef} className={styles.wrapper}>
            {height > 740 ? (
                renderContent()
            ) : (
                <Scrollbar componentClasses={styles.scroll} autoHeight autoHeightMax={maxHeight}>
                    {renderContent()}
                </Scrollbar>
            )}
        </div>
    );
};
